import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';
import { storeFreeze } from 'ngrx-store-freeze';
import { environment } from '../../environments/environment';
import { debug } from './meta-reducers/debug.reducer';
import { RouterStateUrl } from './router/router.state';

export const metaReducers: MetaReducer<AppState>[] = [];

if (!environment.production) {
  metaReducers.unshift(storeFreeze);
  metaReducers.unshift(debug);
}

export const reducer: ActionReducerMap<AppState> = {
  router: routerReducer,
};

export const selectRouterState = createFeatureSelector<RouterReducerState<RouterStateUrl>>('router');

export type AppState = {
  router: RouterReducerState<RouterStateUrl>;
};
